import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

function TransactionView({ data }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  return (
    <div>
      <button className="button-btn btn-sm m-2" onClick={handleShow}>
        View
      </button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Transaction Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <div className="container">
              <div className="row">
                <div className=" col-12">
                  <div className="row mb-3">
                    <div className="col-4 d-flex justify-content-start align-items-center">
                      <p className="text-sm">Order Number</p>
                    </div>
                    <div className="col-8">
                      <p className="text-muted text-sm">
                        : {data?.item_number || "-"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row mb-3">
                    <div className="col-4 d-flex justify-content-start align-items-center">
                      <p className="text-sm">Product</p>
                    </div>
                    <div className="col-8">
                      <p className="text-muted text-sm">
                        : {data?.product?.name || "-"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row mb-3">
                    <div className="col-4 d-flex justify-content-start align-items-center">
                      <p className="text-sm">Commission Earned</p>
                    </div>
                    <div className="col-8">
                      <p className="text-muted text-sm">
                        : ₹{" "}
                        {data?.affiliate_commission !== undefined &&
                        data?.affiliate_commission !== null
                          ? Number(data.affiliate_commission).toFixed(1)
                          : "-"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row mb-3">
                    <div className="col-4 d-flex justify-content-start align-items-center">
                      <p className="text-sm">Quantity</p>
                    </div>
                    <div className="col-8">
                      <p className="text-muted text-sm">
                        : {data?.quantity || "-"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row mb-3">
                    <div className="col-4 d-flex justify-content-start align-items-center">
                      <p className="text-sm">Final Price</p>
                    </div>
                    <div className="col-8">
                      <p className="text-muted text-sm">
                        :{" "}
                        {data?.discount !== undefined && data?.discount !== null
                          ? new Intl.NumberFormat("en-IN", {
                              style: "currency",
                              currency: "INR",
                            }).format(data.discount)
                          : "-"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row mb-3">
                    <div className="col-4 d-flex justify-content-start align-items-center">
                      <p className="text-sm">Discount Percentage</p>
                    </div>
                    <div className="col-8">
                      <p className="text-muted text-sm">
                        :{" "}
                        {data?.discount_percent !== undefined &&
                        data?.discount_percent !== null
                          ? `${Number(data.discount_percent).toFixed(2)}%`
                          : "0%"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row mb-3">
                    <div className="col-4 d-flex justify-content-start align-items-center">
                      <p className="text-sm">Created</p>
                    </div>
                    <div className="col-8">
                      <p className="text-muted text-sm">
                        :{" "}
                        {data?.created_at
                          ? new Date(data.created_at).toLocaleString("en-IN", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "numeric",
                              minute: "2-digit",
                              hour12: true,
                            })
                          : "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default TransactionView;
